import React from "react";
import {
  Modal,
  Row,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Button,
} from "react-bootstrap";

const CreateAddressModal = (props) => {
  const handleOpenGoogleMaps = () => {
    window.open(
      "https://www.google.com/maps",
      "GoogleMaps",
      "width=900,height=700",
    );
  };

  return (
    <Modal
      show={props.show}
      onHide={props.onHide}
      size="lg"
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      bsSize="lg"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {props.mode === "update" ? "Update Address" : "Create New Address"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          <Row>
            <Col md={6}>
              <FormGroup>
                <ControlLabel>Address Line 1</ControlLabel>
                <FormControl
                  name="addressline1"
                  value={props.addressline1}
                  onChange={(event) => {
                    props.handleChange("addressline1", event.target.value);
                  }}
                  placeholder="Enter Address Line 1"
                  type="text"
                />
                {props.validationState &&
                  props.validationState.addressline1Error}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <ControlLabel>Address Line 2</ControlLabel>
                <FormControl
                  name="addressline2"
                  value={props.addressline2}
                  onChange={(event) => {
                    props.handleChange("addressline2", event.target.value);
                  }}
                  placeholder="Enter Address Line 2"
                  type="text"
                />
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <ControlLabel>Enter the location coordinates</ControlLabel>
              <div style={{ display: "flex", gap: "8px" }}>
                <FormControl
                  name="coordinates"
                  type="text"
                  placeholder="Enter your location"
                  value={props.input || ""}
                  onChange={props.handleInputLocationChange}
                  //   onKeyDown={(e) => e.preventDefault()}
                  onPaste={(e) => {
                    e.persist();
                    setTimeout(() => {
                      const pastedValue = e.target.value;
                      props.handleInputLocationChange({
                        target: { value: pastedValue },
                      });
                    }, 0);
                  }}
                  style={{ flex: 1 }}
                />
                <button
                  className="btn btn-primary"
                  onClick={handleOpenGoogleMaps}
                  style={{
                    cursor: "pointer",
                    borderRadius: "4px",
                    border: "none",
                    backgroundColor: "#000000ff",
                    color: "#fff",
                    padding: "8px 15px",
                    height: "100%",
                    minHeight: "34px",
                    marginTop: "6px",
                  }}
                >
                  Get Location
                </button>
              </div>
              {props.validationState && props.validationState.latiAndLogitError}
            </Col>
            <Col md={6}>
              <ControlLabel>Postal code</ControlLabel>
              <FormControl
                name="postalcode"
                value={props.postalcode}
                onChange={(event) => {
                  props.handleChange("postalcode", event.target.value);
                }}
                placeholder="Enter Postal Code"
                type="number"
              />
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <ControlLabel>District</ControlLabel>
                <select
                  className="form-control"
                  name="city"
                  value={props.city}
                  onChange={props.onChange}
                >
                  <option value="0"> Select District</option>
                  {props.city_info.map((city) => (
                    <option value={city.id} key={city.id}>
                      {city.city_name}
                    </option>
                  ))}
                </select>
                {props.validationState && props.validationState.cityError}
              </FormGroup>
            </Col>
            <Col md={6}>
              <FormGroup>
                <ControlLabel>Country</ControlLabel>
                <select
                  name="country"
                  value={props.country || "1"}
                  onChange={props.onChange}
                  className="form-control"
                >
                  {/* <option value="0">Select Country</option> */}
                  {props.country_detail.map((country_data) => (
                    <option value={country_data.id} key={country_data.id}>
                      {country_data.country_name}
                    </option>
                  ))}
                </select>
                {props.validationState && props.validationState.countryError}
              </FormGroup>
            </Col>
          </Row>
          <Row>
            <Col md={6}>
              <FormGroup>
                <ControlLabel>Address type</ControlLabel>
                <br></br>
                <select
                  className="form-control"
                  name="addressType"
                  onChange={(event) => {
                    props.handleChange("addressType", event.target.value);
                  }}
                  value={props.addressType}
                >
                  <option value="">Select address type</option>
                  <option value="Home">Home</option>
                  <option value="Office">Office</option>
                  <option value="Custom">Custom</option>
                </select>
                {props.validationState &&
                  props.validationState.addressTypeError}
              </FormGroup>
            </Col>
            <Col md={6}>
              {props.addressType === "Custom" && (
                <FormGroup>
                  <ControlLabel>Custom Address Type</ControlLabel>
                  <FormControl
                    name="customAddress"
                    value={props.customAddress}
                    onChange={(event) => {
                      props.handleChange("customAddress", event.target.value);
                    }}
                    placeholder="Enter Custom Address Type"
                    type="text"
                  />
                  {/* {customAddressTypeError} */}
                </FormGroup>
              )}
            </Col>
          </Row>
          {props.showParcelRestrictedOption && ( 
            <Row>
              <Col md={12}>
                <FormGroup>
                  <label className="parcel-restricted-checkbox">
                    <input
                      type="checkbox"
                      checked={Boolean(props.isParcelRestrictedZone)}
                      onChange={(event) =>
                        props.setIsParcelRestrictedZone &&
                        props.setIsParcelRestrictedZone(event.target.checked)
                      }
                    />{" "}
                    In BIO zone
                  </label>
                </FormGroup>
              </Col>
            </Row>
          )}
          <button
            style={{
              cursor: "pointer",
              borderRadius: "4px",
              border: "none",
              backgroundColor: "#000000ff",
              color: "#fff",
              padding: "8px 15px",
            }}
            onClick={props.onSubmitAddress}
          >
            {props.mode === "update" ? "Update Address" : "Save Address"}
          </button>
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default CreateAddressModal;
